// extracted by mini-css-extract-plugin
module.exports = {"header":"_2ZasYDxiwgQ-wIpHWKysMi","label":"_3l8DN8adWzPxMnX1I4EBNa","value":"_2GxVSbT4MorAXQnzNqvKQD","divider":"AtGOYGC5SibOyI_n0zxre"};